import { ConfigProvider, ThemeConfig } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { memo, useMemo } from 'react';
import { IBaseProps } from 'src/types/common.type';

dayjs.locale('vi');

function AntdProvider({ children }: IBaseProps) {
  const theme = useMemo<ThemeConfig>(() => {
    return {
      token: {
        fontFamily: 'Lexend',
        colorPrimary: '#ed1c24',
      },
      components: {
        // Layout: {
        //   headerBg: 'white',
        //   bodyBg: 'white',
        //   footerBg: 'white',
        // },
      },
    };
  }, []);

  return (
    <ConfigProvider locale={viVN} theme={theme}>
      {children}
    </ConfigProvider>
  );
}

export default memo(AntdProvider);
